/**
 * PlacementHinweisbox — the snapshot/promotion note shown atop BOTH Ausschreibungs-Screen tabs
 * (Ch 7.3). The text lives in @brokly/shared (PLACEMENT_HINWEISBOX_TEXT) so it stays in one place.
 */

import { Info } from 'lucide-react';
import { PLACEMENT_HINWEISBOX_TEXT } from '@brokly/shared';

export function PlacementHinweisbox() {
  return (
    <div
      className="flex items-start gap-2 rounded-lg border border-dashed bg-muted/30 p-3 text-xs text-muted-foreground"
      data-testid="placement-hinweisbox"
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <span>{PLACEMENT_HINWEISBOX_TEXT}</span>
    </div>
  );
}
